import { Point } from "mapbox-gl";
import { RootStore } from "../../shared/stores/RootStore";
import { nodeReferences } from "../../osaway/stores/OsaNodeStore";
import { osaNodeShiftDragLayerName } from "./OsaMapSource";
import { hlaWayShiftDragLayerName } from "./HlaMapSource";
import { BBoxSelection } from "./BBoxSelection";

export class ShiftDragSelection {
  map: mapboxgl.Map;
  rootStore: RootStore;
  bboxSelection?: BBoxSelection;

  selectOsaNodes = false;
  selectHlaWays = false;

  constructor(map: mapboxgl.Map, rootStore: RootStore) {
    this.map = map;
    this.rootStore = rootStore;
  }

  setSelectOsaNodes(value: boolean) {
    this.selectOsaNodes = value;
  }

  setSelectHlaWays(value: boolean) {
    this.selectHlaWays = value;
  }

  disable() {
    this.bboxSelection?.disable();
  }

  enable() {
    this.bboxSelection = new BBoxSelection(this.map, {
      onDrag: (bbox) => this.onFinish(bbox),
      onClick: (point) => this.onFinish(point),
    });
    this.bboxSelection.enable();
  }

  onFinish(query: Point | [Point, Point]) {
    const { osaWayStore, osaNodeStore, hlaStore } = this.rootStore;

    if (this.selectOsaNodes) {
      const selectedWay = osaWayStore.getSelected();
      if (selectedWay) {
        const features = this.map.queryRenderedFeatures(query, {
          layers: [osaNodeShiftDragLayerName],
        });

        features.forEach((f) => {
          const nodeId = f.properties?.id as string;

          const nodeIsInSelectedWay =
            nodeReferences.get(nodeId)?.osaWayId === selectedWay.id;
          if (nodeIsInSelectedWay) {
            osaNodeStore.toggleMultiSelectedId(nodeId);
          }
        });
      }
    }

    if (this.selectHlaWays) {
      const features = this.map.queryRenderedFeatures(query, {
        layers: [hlaWayShiftDragLayerName],
      });

        const hlaWayIds = new Set(
          features.map((f) => f.properties?.hlaWayId as string),
        );

      hlaWayIds.forEach((hlaWayId) => {
        hlaStore.toggleMultiSelectedId(hlaWayId);
      });
    }
  }
}
